import Chevron from 'src/app/icons/Monospaced/Chevron/Chevron';
import styled from 'styled-components';

export const ChevronIcon = styled(Chevron)`
  transition: transform 0.3s ease-in-out;
`;
